export default "__VITE_ASSET__Dt8Ot3UM__"